<!-- The grid's generic "Filter by" is off here, as on the Customers page: the two lookups people
     arrive knowing — account number and customer name — have their own boxes instead. -->
<!-- Server mode: one page at a time from GET /customers; paging, sort and both lookups go to FTE. -->
<app-grid
  [data]="rows"
  [config]="config"
  [enableColumnFilters]="false"
  [parent]="parent"
  [isSelectedFunc]="isSelectedFunc"
  [serverSide]="true"
  [totalLength]="total()"
  [pageIndex]="pageIndex()"
  [sortActive]="sort().active"
  [sortDirection]="sort().direction"
  [loading]="loading()"
  (pageChange)="onPage($event)"
  (sortChange)="onSort($event)"
  (select)="selectCustomer($event)"
>
  <div gridToolbarLeft class="app-payment-collect-customers__lookups">
    <div class="search-input app-payment-collect-customers__lookup">
      <input
        [formControl]="accountNumberFilter"
        type="text"
        placeholder="Account number"
        aria-label="Filter by account number"
      />
    </div>
    <div class="search-input app-payment-collect-customers__lookup">
      <input
        [formControl]="customerNameFilter"
        type="text"
        placeholder="Customer name"
        aria-label="Filter by customer name"
      />
    </div>
    @if (hasLookup()) {
      <button
        type="button"
        mat-button
        color="warn"
        class="app-payment-collect-customers__lookup-clear"
        (click)="clearLookups()"
        aria-label="Clear the account number and customer name filters"
      >
        <mat-icon>backspace</mat-icon>
        <span>Clear</span>
      </button>
    }
  </div>
</app-grid>
